module.exports = __webpack_public_path__ + "static/img/down_btn1.69dd8b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/down_btn1.png
// module id = y6TO
// module chunks = 4